import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import ReactTooltip from "react-tooltip";
import dayjs from "dayjs";
import { Helmet } from "react-helmet";
import classNames from "classnames";

import CalendarHeatmap from "react-calendar-heatmap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./ChimneyProfile.less";

import MediaProvider from "~/Components/library/MediaProvider";
import ChimneyProfileContainer from "./Containers/ChimneyProfileContainer";
import ChimneyProfileTracksContainer from "./Containers/ChimneyProfileTracksContainer";
import ProfileSocial from "./ProfileSocial";
import ProfileTopTen from "./ProfileTopTen";
import ProfileWebsites from "./ProfileWebsites";
import ProfileFavoriteArtists from "./ProfileFavoriteArtists";
import ProfileFavoriteGenres from "./ProfileFavoriteGenres";
import ProfileMostRecentPurchase from "./ProfileMostRecentPurchase";
import TrackDetails from "../Track/TrackDetails";
import TrackHeader from "../Track/TrackHeader";
import TrackBoxes from "../../Components/Elements/TrackBoxes";
import TrackFooter from "../Track/TrackFooter";
import TrackBoxCounter from "../../Components/Elements/TrackBoxCounter";
// import TracksGraphContainer from "../../Containers/TracksGraphContainer";
import ProfileArchiveReason from "./ProfileArchiveReason";
import ProfileArchiveSelect from "./ProfileArchiveSelect";
import { useUser } from "~/Context/userContext";

import FeatureCallOutContainer from "~/Containers/FeatureCallOutContainer";
import { ThemeProvider, DEFAULT_THEME } from "@zendeskgarden/react-theming";
import { Tooltip } from "@zendeskgarden/react-tooltips";
import RecentUserPlaylists from "~/Components/SideNav/RecentUserPlaylists";

const ChimneyProfilePage = ({ match }) => {
  let history = useHistory();
  const { state: userState } = useUser();
  const [chimDir, setChimDir] = useState(match.params.chimDir);
  const isOwner = userState.loggedin && userState.isChim && userState.user && userState.user.dir === match.params.chimDir;
  const months = 12;
  function getStartDate(cell, row) {
    return dayjs().subtract({ months }).format("YYYY-MM-DD");
  }
  function getEndDate(cell, row) {
    return dayjs().format("YYYY-MM-DD");
  }
  useEffect(() => {
    setChimDir(match.params.chimDir);
  }, [match]);

  return (
    <div className="chimney-profile-page-component">
      <ChimneyProfileContainer
        chimDir={chimDir}
        render={({ profile, loading }) => {
          if (loading) return <Spinner animation="border" variant="dark" />;
          return (
            !loading && (
              <React.Fragment>
                <Helmet>
                  <title>{profile.full_name} Chimney | Dream Chimney</title>
                </Helmet>
                <Row>
                  <Col xs={12}>
                    {loading && <Spinner animation="border" variant="dark" />}
                    {!loading && <h1>{profile.full_name} Chimney</h1>}
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={12} md={8}>
                    <div>
                      <MediaProvider>
                        <ChimneyProfileTracksContainer
                          chimDir={chimDir}
                          page={1}
                          render={({ tracks, pager, loading }) => (
                            <div>
                              <div className="totd-header">
                                <h3>Most Recent Track</h3>
                              </div>
                              <div className="profile-most-recent-track">
                                <TrackHeader track={tracks[0]} trackLink rerule={false} />
                                <TrackDetails loading={loading} track={tracks[0]} />
                                <TrackFooter track={tracks[0]} />
                              </div>
                              {/* <div className="trackPostedMonths">
                                <h5>
                                  Tracks posted by {profile.full_name} Chimney in the last {months} months
                                </h5>
                                <TracksGraphContainer
                                  chimdir={chimDir}
                                  render={({ values }) => (
                                    <div>
                                      <CalendarHeatmap
                                        startDate={getStartDate()}
                                        endDate={getEndDate()}
                                        weekdayLabels={["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]}
                                        values={values}
                                        showMonthLabels={true}
                                        showWeekdayLabels={true}
                                        onClick={(value) => {
                                          history.push(`/${value.id}`);
                                        }}
                                        tooltipDataAttrs={(value) => {
                                          if (value.track) {
                                            return {
                                              "data-tip": `${value.track}`,
                                            };
                                          } else {
                                            return null;
                                          }
                                        }}
                                      // onClick={value => alert(value.date)}
                                      />
                                      <ReactTooltip />
                                    </div>
                                  )}
                                />
                              </div> */}
                              {pager.total > 1 && (
                                <React.Fragment>
                                  <div>
                                    <div className="totd-header bw">Recent Tracks posted by {profile.full_name} Chimney</div>
                                    {<TrackBoxes tracks={tracks.slice(1)} />}
                                  </div>
                                  {pager.hasMore && (
                                    <div>
                                      <div className="pagination-wrapper">
                                        <Link className="pagination pagination-item" to={`/profile/${chimDir}/tracks/2`}>
                                          More Tracks
                                        </Link>
                                      </div>
                                    </div>
                                  )}
                                </React.Fragment>
                              )}
                            </div>
                          )}
                        />
                      </MediaProvider>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={4} className="right-nav">
                    <div
                      className={classNames({
                        "profile-name": true,
                        "profile-name-long": profile.full_name.length >= 12,
                      })}
                    >
                      <h2>{profile.full_name} Chimney</h2>
                      {profile.aka && <span>AKA {profile.aka}</span>}
                    </div>
                    <div>
                      <TrackBoxCounter count={profile.total_tracks} />
                    </div>
                    <div>
                      <div>
                        {
                          <ThemeProvider
                            theme={{
                              ...DEFAULT_THEME,
                              rtl: true,
                              colors: { ...DEFAULT_THEME.colors, background: "#4a4a9b", neutralHue: "#fff" },
                            }}
                          >
                            <FeatureCallOutContainer
                              featureId="totd_status_updates"
                              render={({ show, markAsViewed }) => (
                                <div>
                                  <Tooltip
                                    type="light"
                                    isInitialVisible={false}
                                    isVisible={isOwner && show}
                                    placement="top-start"
                                    size="large"
                                    content={
                                      <>
                                        <h3>Status</h3>
                                        <p>
                                          You can now share a quick status update anytime.{" "}
                                          <Link to={`/profile/edit/details`} style={{ color: "#fff" }}>
                                            Add one now
                                          </Link>
                                        </p>
                                        <div>
                                          <button onClick={markAsViewed}>Ok Cool</button>
                                        </div>
                                      </>
                                    }
                                  >
                                    <div
                                      style={{
                                        margin: "0 0 20px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          border: "1px solid #ccc",
                                          backgroundColor: "#ccc",
                                          padding: "10px 10px 4px 10px",
                                        }}
                                      >
                                        <strong>{isOwner ? `Your` : ``} Status</strong>:{" "}
                                        {profile.vacation !== "" ? profile.vacation : `Unknown`}
                                      </div>
                                      {isOwner && (
                                        <div style={{ position: "absolute", right: "18px", marginTop: 4, fontSize: "11px" }}>
                                          <Link to={`/profile/edit/details`}>
                                            <FontAwesomeIcon icon={["fas", "edit"]} style={{ marginLeft: "6px" }} /> Update
                                          </Link>
                                        </div>
                                      )}
                                    </div>
                                  </Tooltip>
                                </div>
                              )}
                            />
                          </ThemeProvider>
                        }
                      </div>
                      <div>
                        <strong>Location</strong>: {profile.location}
                      </div>
                      <div>
                        <strong>Member since</strong>: {profile.member_since}
                      </div>
                      <div>
                        <span>
                          <strong>Musical Expertise</strong>:
                        </span>{" "}
                        {profile.favorite_genre.genre ? (
                          <Link to={`/genre/${profile.favorite_genre.genre_id}`}>{profile.favorite_genre.genre}</Link>
                        ) : (
                          `None`
                        )}
                      </div>
                    </div>
                    {!isOwner && (
                      <React.Fragment>
                        <h3>Contact</h3>
                        <div>
                          <div>
                            <FontAwesomeIcon icon="envelope" className="envelope" />{" "}
                            <Link to={`/profile/${profile.chim_dir}/contact`}>Send {profile.full_name} a message</Link>
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                    {profile.most_recent_img && <ProfileMostRecentPurchase profile={profile} />}
                    {profile.social && <ProfileSocial profile={profile} />}
                    {chimDir && <ProfileFavoriteArtists dir={chimDir} isOwner={isOwner} />}
                    {chimDir && <ProfileFavoriteGenres dir={chimDir} isOwner={isOwner} />}
                    {chimDir && <RecentUserPlaylists dir={chimDir} limit={5} />}
                    {profile.reason_to_be_chim && <ProfileArchiveReason reason={profile.reason_to_be_chim} />}
                    <ProfileTopTen chimDir={chimDir} />
                    <ProfileWebsites chimDir={chimDir} />
                    <ProfileArchiveSelect title={'Archive'} chimDir={chimDir} memberSince={profile.member_since} />
                  </Col>
                </Row>
              </React.Fragment>
            )
          );
        }}
      />
    </div>
  );
};

export default ChimneyProfilePage;
